<!--抽奖抽中弹框-->
<template>
  <van-popup
    v-model="popupShow"
    closeable
    :close-on-click-overlay="false"
    close-icon="close"
    get-container="body"
    :class="[isPc?'popup-p-pc':'popup-p']"
    @click-close-icon="closePopup"
  >
    <div class="draw-success-p">
      <div
        class="draw-success-header"
        :style="{background: 'url('+drawBgImg+') center center no-repeat', backgroundSize: isPc?'5.75rem 1.14rem':'3.75rem 1.14rem'}"
      >{{content.drawResult}}</div>
      <div class="draw-success-body">
        <div class="real-gift-p">
          <van-image
            class="true-gift"
            :width="isPc?'1.52rem':'1.22rem'"
            :height="isPc?'1.22rem':'0.95rem6'"
            :src="giftImg"
          />
          <div class="gift-tip">{{content.congratulations}} <br /> {{form.prize.title}}</div>
        </div>
        <div class="perfect-p">
          <div class="title">{{content.perfectAddress}}</div>
          <van-field
            v-model="form.name"
            size="small"
            maxlength="40"
            :label="content.name+':'"
            label-width="0.62rem"
            :placeholder="content.loginNameTip"
            :readonly="form.type == 'detail'"
          />
          <van-field
            v-model="form.tel"
            size="small"
            maxlength="11"
            :label="content.tel+':'"
            label-width="0.62rem"
            :placeholder="content.telTip"
            :readonly="form.type == 'detail'"
          />
          <van-field
            v-model="form.email"
            size="small"
            maxlength="80"
            :label="content.email+':'"
            label-width="0.62rem"
            :placeholder="content.emailResTip"
            :error-message="emailErrorMsg"
            :readonly="form.type == 'detail'"
          />
          <van-field
            v-model="form.receiving_address"
            size="small"
            maxlength="80"
            :label="content.address+':'"
            label-width="0.62rem"
            :placeholder="content.addressTip"
            :readonly="form.type == 'detail'"
          />
          <van-checkbox
            class="cbx-box"
            :icon-size="isPc?'0.21rem':'0.1rem'"
            v-model="isChecked"
          >{{content.agreementTip}}</van-checkbox>
        </div>
        <div class="form-btn">
          <van-button
            @click="submitForm"
            :disabled="!canSubmit"
          >{{form.type == 'edit'?content.submit:content.submited}}</van-button>
        </div>
        <div class="form-tip">{{content.emailTip}}</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from 'vuex'
import { postUpdateRaffleWinning } from '@/models/common'
export default {
  data() {
    return {
      drawBgImg: require('@/assets/imgs/draw-success-header.png'),
      giftImg: require('@/assets/imgs/draw-gift.png'),
      popupShow: false,
      form: {
        winning_id: '', // 中奖记录id
        name: '', // 姓名
        tel: '', // 电话
        email: '', // 邮箱
        receiving_address: '', // 地址
        type: 'edit', // 是否只读 detail edit
        prize: {
          title: '', // 奖品名称
          id: ''
        }
      },
      emailErrorMsg: '', // 邮箱格式验证
      isChecked: false, // 是否同意免责声明
    }
  },
  computed: {
    canSubmit() {
      return (this.form.name != '' && this.form.tel != '' && this.form.email != '' && this.form.receiving_address != ''
        && this.form.name != null && this.form.tel != null && this.form.email != null && this.form.receiving_address != null) && this.form.type == 'edit' && this.isChecked
    },
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc'])
  },
  methods: {
    show(obj) {
      this.popupShow = true
      this.form = Object.assign(this.form, obj)
    },
    close() {
      this.popupShow = false
    },
    // 提交中奖记录
    submitForm() {
      if (!/^\w+([\u4e00-\u9fa5-+.]*\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.form.email)) {
        this.emailErrorMsg = this.lanuage=='Chinese'?'请输入正确的邮箱格式':'Please enter the correct mailbox format'
        return
      } else {
        this.emailErrorMsg = ''
      }
      postUpdateRaffleWinning({ ...this.form }).then(res => {
        if (res.data.code == 0) {
          this.$toast(this.content.saveSuccess)
          this.form.type = 'detail'
        }
      })
    },
    closePopup() {
      this.popupShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.popup-p-pc{
  background-color: transparent;
  overflow-y: visible;
  .draw-success-p {
    width: 5.26rem;
    // height: 4.9rem;
    position: relative;
    padding-top: 0.5rem;
    .draw-success-header {
      width: 5.75rem;
      height: 1.14rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -0.44rem;
      padding-top: 0.46rem;
      text-align: center;
      font-size: 0.3rem;
      color: #fff;
      box-sizing: border-box;
      z-index: -1;
    }
    .draw-success-body {
      width: 5.26rem;
      // height: 4.78rem;
      background-color: #fff;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      z-index: 2;
      .real-gift-p {
        padding-top: 0.16rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .gift-tip {
          color: #fe3f3d;
          font-size: 0.2rem;
          margin-top: 0.16rem;
          text-align: center;
        }
      }
      .perfect-p {
        margin-top: 0.22rem;
        padding: 0 0.2rem;
        .title {
          color: #000;
          font-size: 0.2rem;
        }
        /deep/.van-field {
          padding: 0.14rem 0;
          .van-field__label {
            font-size: 0.2rem;
          }
          .van-field__value {
            font-size: 0.2rem;
          }
        }
        .cbx-box {
          padding: 0.14rem 0;
          /deep/.van-checkbox__label {
            font-size: 0.18rem;
            color: #cdcdcd;
            margin-bottom: -0.03rem;
          }
        }
      }
      .form-btn {
        text-align: center;
        margin-top: 0.06rem;
        display: flex;
        justify-content: center;
        .van-button {
          background-color: #fde73a;
          box-shadow: 0rem 0.03rem 0rem 0rem rgba(255, 148, 8, 0.8);
          border-radius: 10px;
          padding: 0.03rem 0.14rem 0.02rem;
          font-size: 0.22rem;
          color: #cd410a;
          font-weight: normal;
          height: 0.42rem;
          width: 1.47rem;
        }
      }
      .form-tip {
        text-align: center;
        margin-top: 0.16rem;
        color: #262745;
        font-size: 0.12rem;
        padding-bottom: 0.12rem;
      }
    }
  }
  /deep/.van-popup__close-icon {
    top: -0.65rem;
    right: 0;
    color: #fff;
    font-size: 0.39333rem;
  }
}
.popup-p {
  background-color: transparent;
  overflow-y: visible;
  .draw-success-p {
    width: 3.26rem;
    // height: 4.9rem;
    position: relative;
    padding-top: 0.5rem;
    .draw-success-header {
      width: 3.75rem;
      height: 1.14rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -0.44rem;
      padding-top: 0.46rem;
      text-align: center;
      font-size: 0.3rem;
      color: #fff;
      box-sizing: border-box;
      z-index: -1;
    }
    .draw-success-body {
      width: 3.26rem;
      // height: 4.78rem;
      background-color: #fff;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      z-index: 2;
      .real-gift-p {
        padding-top: 0.16rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .gift-tip {
          color: #fe3f3d;
          font-size: 0.16rem;
          margin-top: 0.16rem;
          text-align: center;
        }
      }
      .perfect-p {
        margin-top: 0.22rem;
        padding: 0 0.2rem;
        .title {
          color: #000;
          font-size: 0.16rem;
        }
        /deep/.van-field {
          padding: 0.07rem 0;
          .van-field__label {
            font-size: 0.16rem;
          }
          .van-field__value {
            font-size: 0.16rem;
          }
        }
        .cbx-box {
          padding: 0.06rem 0;
          /deep/.van-checkbox__label {
            font-size: 0.12rem;
            color: #cdcdcd;
            margin-bottom: -0.03rem;
          }
        }
      }
      .form-btn {
        text-align: center;
        margin-top: 0.06rem;
        display: flex;
        justify-content: center;
        .van-button {
          background-color: #fde73a;
          box-shadow: 0rem 0.03rem 0rem 0rem rgba(255, 148, 8, 0.8);
          border-radius: 10px;
          padding: 0.03rem 0.14rem 0.02rem;
          font-size: 0.22rem;
          color: #cd410a;
          font-weight: normal;
          height: 0.42rem;
          width: 1.47rem;
        }
      }
      .form-tip {
        text-align: center;
        margin-top: 0.16rem;
        color: #262745;
        font-size: 0.12rem;
        padding-bottom: 0.12rem;
      }
    }
  }
  /deep/.van-popup__close-icon {
    top: -0.65rem;
    right: 0;
    color: #fff;
  }
}
</style>